import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Typography,
  useMediaQuery,
} from "@mui/material";

import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';

import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

import { MdSpaceDashboard } from "react-icons/md";
import { FaCalendarAlt, FaCog } from "react-icons/fa";

import { Badge } from "@mui/material";
import { database } from "../services/firebase";
import { ref, onValue } from "firebase/database";

import Logo from "../assets/logouaithaiPreta.png";

export default function Aside() {
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [open, setOpen] = useState(false);

  const [messagesCount, setMessagesCount] = useState(0);

  useEffect(() => {
    const messagesRef = ref(database, "messages");

    const unsubscribe = onValue(messagesRef, (snapshot) => {
      if (!snapshot.exists()) {
        setMessagesCount(0);
        return;
      }

      const now = Date.now();
      const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000;

      const data = snapshot.val();

      const countLast7Days = Object.values(data).filter(
        (msg) => msg.createdAt && msg.createdAt >= sevenDaysAgo
      ).length;

      setMessagesCount(countLast7Days);
    });

    return () => unsubscribe();
  }, []);

  const [pendentesCount, setPendentesCount] = useState(0);

  useEffect(() => {
    const reservasRef = ref(database, "reservas");

    const unsubscribe = onValue(reservasRef, (snapshot) => {
      if (!snapshot.exists()) {
        setPendentesCount(0);
        return;
      }

      let count = 0;

      Object.values(snapshot.val()).forEach((periodos) => {
        ["almoco", "jantar"].forEach((periodo) => {
          if (periodos?.[periodo]) {
            Object.values(periodos[periodo]).forEach((r) => {
              if (r.status === "pendente") count++;
            });
          }
        });
      });

      setPendentesCount(count);
    });

    return () => unsubscribe();
  }, []);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    sessionStorage.removeItem("auth");
    window.location.href = "/";
  };

  const menu = (
    <Box
      sx={{
        width: 260,
        height: "10%",
        display: "flex",
        flexDirection: "column",
        p: 2,

      }}
    >
      {/* LOGO */}
      <Box sx={{ mb: 3, px: 1 }}>
        <img src={Logo} alt="UaiThai" style={{ width: 150 }} />
      </Box>

      <Typography
        sx={{
          textAlign: "left",
          fontSize: 12,
          fontWeight: 700,
          opacity: 0.6,
          mb: 1,
          ml: 1,
        }}
      >
        GERAL
      </Typography>

      <List sx={{ p: 0 }}>
        <ListItemButton
          component={Link}
          to="/admin/dashboard"
          sx={{
            borderRadius: 2,
            mb: 0.5,
            background: isActive("/admin/dashboard")
              ? "rgba(28,100,242,0.12)"
              : "",
          }}
        >
          <ListItemIcon sx={{ minWidth: 38 }}>
            <Badge
              badgeContent={pendentesCount}
              color="warning"
              invisible={pendentesCount === 0}
              overlap="circular"
            >
              <MdSpaceDashboard size={20} />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Painel" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/admin/reservas"
          sx={{
            borderRadius: 2,
            mb: 0.5,
            background: isActive("/admin/reservas")
              ? "rgba(28,100,242,0.12)"
              : "",
          }}
        >
          <ListItemIcon sx={{ minWidth: 38 }}>
            <FaCalendarAlt size={18} />
          </ListItemIcon>
          <ListItemText primary="Reservas" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/admin/config"
          sx={{
            borderRadius: 2,
            mb: 0.5,
            background: isActive("/admin/config")
              ? "rgba(28,100,242,0.12)"
              : "",
          }}
        >
          <ListItemIcon sx={{ minWidth: 38 }}>
            <FaCog size={18} />
          </ListItemIcon>
          <ListItemText primary="Configurações" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/admin/mensagens"
          sx={{
            borderRadius: 2,
            mb: 0.5,
            background: isActive("/admin/mensagens")
              ? "rgba(28,100,242,0.12)"
              : "",
          }}
        >
          <ListItemIcon sx={{ minWidth: 38 }}>
            <Badge
              badgeContent={messagesCount}
              color="error"
              invisible={messagesCount === 0}
              overlap="circular"
            >
              <MarkEmailUnreadIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Mensagens" />
        </ListItemButton>
      </List>

      <Divider sx={{ my: 2 }} />

      {/* LOGOUT */}
      <ListItemButton
        onClick={handleLogout}
        sx={{
          borderRadius: 2,
          color: "error.main",
          height: 40,
        }}
      >
        <ListItemIcon sx={{ minWidth: 38, color: "error.main" }}>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary="Sair" />
      </ListItemButton>
    </Box>
  );

  return (
    <>
      {/* HEADER MOBILE */}
      {isMobile && (
        <Box
          sx={{
            height: 64,
            px: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #eee",
          }}
        >
          <IconButton onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>

          <img src={Logo} alt="logo" style={{ height: 32 }} />

          <IconButton onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Box>
      )}

      {/* DESKTOP */}
      {!isMobile && (
        <Box
          sx={{
            width: 260,
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            borderRight: "1px solid #eee",
            background: "#fff",
          }}
        >
          {menu}
        </Box>
      )}

      {/* DRAWER MOBILE */}
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{ keepMounted: true }}
      >
        {menu}
      </Drawer>
    </>
  );
}
